import { defineMessages } from "react-intl";
import { stdnum } from "stdnum";

const CA_TAX_IDS = {
  SIN: "SIN",
  BN: "BN",
};

const CA_TAX_IDS_META = {
  [CA_TAX_IDS.SIN]: {
    type: CA_TAX_IDS.SIN,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.sin_short_name",
        defaultMessage: "SIN",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.sin_name",
        defaultMessage: "Social Insurance Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.sin_full_name",
        defaultMessage: "Social Insurance Number (SIN)",
      },
    }),
    validationFn: stdnum.CA.sin.validate,
    format: "000-000-000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.sin_format",
        defaultMessage: "9-digit",
      },
    }),
  },
  [CA_TAX_IDS.BN]: {
    type: CA_TAX_IDS.BN,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.bn_short_name",
        defaultMessage: "BN",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.bn_name",
        defaultMessage: "Business Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.bn_full_name",
        defaultMessage: "Business Number (BN)",
      },
    }),
    validationFn: stdnum.CA.bn.validate,
    format: "000000000 RT 0000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.bn_format",
        defaultMessage: "9 digits followed by RT and 4 digits",
      },
    }),
  },
};

const CA_VAT_IDS = {
  GST_HST: "GST_HST",
};

const CA_VAT_IDS_META = {
  [CA_VAT_IDS.GST_HST]: {
    type: CA_VAT_IDS.GST_HST,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.gst_hst_short_name",
        defaultMessage: "GST/HST",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.gst_hst_name",
        defaultMessage: "Goods and Services Tax / Harmonized Sales Tax",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.gst_hst_full_name",
        defaultMessage:
          "Goods and Services Tax / Harmonized Sales Tax (GST/HST)",
      },
    }),
    validationFn: stdnum.CA.gst.validate,
    format: "000000000 RT 0000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.gst_hst_format",
        defaultMessage: "9 digits followed by RT and 4 digits",
      },
    }),
  },
};

export { CA_TAX_IDS_META, CA_TAX_IDS, CA_VAT_IDS_META, CA_VAT_IDS };
